import React from "react";
import SvgRightCaret from "../../../../assets/icons/SvgRightCaret";
import InternalDrawer from "../../../common/InternalDrawer";
import MenuLink from "./MenuLink";

export default function MenuDrawer({
  isOpen,
  setMainDrawer,
  title,
  data = [],
}) {
  return (
    <InternalDrawer isOpen={isOpen}>
      <React.Fragment>
        <div className="flex flex-col">
          <div
            className="px-[30px] py-5 flex items-center cursor-pointer"
            role="button"
            onClick={() => setMainDrawer("home")}
          >
            <SvgRightCaret
              style={{
                width: "12px",
                height: "12px",
                transform: "rotate(90deg)",
              }}
            />
            <p className="text-xl font-bold flex-grow text-center">{title}</p>
          </div>
        </div>
        <div className="flex flex-col mt-5 px-8 mb-11 pb-10">
          {data.map((collection) => (
            <MenuLink
              key={collection.title}
              title={collection.title}
              showCaretIcon={false}
              to={collection.slug}
            />
          ))}
        </div>
      </React.Fragment>
    </InternalDrawer>
  );
}
